import useSWR from 'swr';
import { CreateSearchPaginatedQuery, SoundPackage } from '@bpm-web-app/api-client';
import useSWRInfinite from 'swr/infinite';

export function useSearchPack(query: CreateSearchPaginatedQuery) {
    const opts = {
        persist: false,
        ...query,
    };

    const { data, error } = useSWR(['create-search-pack', opts], () => SoundPackage.getSoundPackages(query));

    return {
        data,
        isLoading: !error && !data,
        error,
    };
}

export function useInfiniteSearchPack(query: CreateSearchPaginatedQuery, enabled = true) {
    const pageSize = query?.limit || 50;

    const { data, error, size, setSize, isValidating } = useSWRInfinite(
        (index) => [`create-search-pack-${JSON.stringify({ ...query, enabled })}-${index}`],
        (key) => {
            /* extract page index back from key name */
            const pageIndex = key.split('-').pop() || '0';
            return enabled
                ? SoundPackage.getSoundPackages({
                    ...query,
                    skip: +pageIndex * pageSize,
                })
                : null;
        }
    );

    const isLoadingInitialData = !data && !error;
    const isLoadingMore = isLoadingInitialData || (size > 0 && data && typeof data[size - 1] === 'undefined');
    const isEmpty = data?.[0]?.data.length === 0;
    const lastPageSize = data ? data[data.length - 1]?.data.length || 0 : 0;
    const isLastPage = isEmpty || lastPageSize < pageSize;

    return {
        data,
        isLoadingInitialData,
        isLoadingMore,
        isValidating,
        isLastPage,
        error,
        size,
        setSize,
    };
}
